import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { ScheduleProvider } from "@/context/ScheduleContext";
import Layout from "@/components/Layout";
import AdminShell from "@/components/admin/AdminShell";
import Login from "@/pages/Login";
import Catalog from "@/pages/Catalog";
import Templates from "@/pages/Templates";
import Checkout from "@/pages/Checkout";
import ItemDetail from "@/pages/ItemDetail";
import MyBookings from "@/pages/MyBookings";
import BookingDetail from "@/pages/BookingDetail";
import QueuePage from "@/pages/admin/QueuePage";
import BookingsPage from "@/pages/admin/BookingsPage";
import InventoryPage from "@/pages/admin/InventoryPage";
import AccessPage from "@/pages/admin/AccessPage";
import ReportsPage from "@/pages/admin/ReportsPage";
import ActivityPage from "@/pages/admin/ActivityPage";
import "@/App.css";

function Protected({ children, adminOnly }) {
  const { user } = useAuth();
  if (user === null) return <div className="flex min-h-screen items-center justify-center bg-[#09090B] text-zinc-500">Memuat…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  if (adminOnly) return <AdminShell>{children}</AdminShell>;
  return <Layout>{children}</Layout>;
}

function Shell() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Catalog /></Protected>} />
      <Route path="/checkout" element={<Protected><Checkout /></Protected>} />
      <Route path="/paket" element={<Protected><Templates /></Protected>} />
      <Route path="/barang/:id" element={<Protected><ItemDetail /></Protected>} />
      <Route path="/peminjaman" element={<Protected><MyBookings /></Protected>} />
      <Route path="/peminjaman/:id" element={<Protected><BookingDetail /></Protected>} />
      <Route path="/admin" element={<Protected adminOnly><QueuePage /></Protected>} />
      <Route path="/admin/peminjaman" element={<Protected adminOnly><BookingsPage /></Protected>} />
      <Route path="/admin/peminjaman/:id" element={<Protected adminOnly><BookingDetail /></Protected>} />
      <Route path="/admin/inventaris" element={<Protected adminOnly><InventoryPage /></Protected>} />
      <Route path="/admin/akses" element={<Protected adminOnly><AccessPage /></Protected>} />
      <Route path="/admin/laporan" element={<Protected adminOnly><ReportsPage /></Protected>} />
      <Route path="/admin/aktivitas" element={<Protected adminOnly><ActivityPage /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <ScheduleProvider>
            <Shell />
          </ScheduleProvider>
          <Toaster theme="dark" position="top-right" offset={{ top: 88, right: 20 }} />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
